import {
  HttpEvent,
  HttpHandler,
  HttpRequest,
  HttpInterceptor,
  HttpResponse,
  HttpContextToken
} from '@angular/common/http';
import { Observable, of, tap } from 'rxjs';
import { Injectable } from '@angular/core';
import { CacheType, CPStorageService } from '../cpstorage.service';
import { environment } from '@env/environment';
import { CommonValues } from '../../static/CommonValues';

export class CacheRequestOptions {
  ttl: number;
  cacheType: CacheType;

  /**
   * Creates an instance of CacheRequestOptions.
   * @param {number} ttl value in seconds. -1 is no expiration
   * @param {CacheType} cacheType [Session|Local]
   * @memberof CacheRequestOptions
   */
  constructor(ttl: number, cacheType: CacheType) {
    this.ttl = ttl;
    this.cacheType = cacheType;
  }
}

export const HTTP_CACHE_REQUEST_OPTIONS = new HttpContextToken<CacheRequestOptions | null>(() => null);

@Injectable({
  providedIn: 'root'
})
export class CachingInterceptor implements HttpInterceptor {

  constructor(private storageService: CPStorageService) {
  }
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {

    const cacheOptions = req.context.get(HTTP_CACHE_REQUEST_OPTIONS);

    if (req.method === 'PUT' || req.method === 'POST' || req.method === 'PATCH' || req.method === 'DELETE') {
      // NOTE: Keep this for now. This currently wont work cause we use POST to do gets :(
      // const parts = req.url.split('/api/').slice(1)[0].split('/');
      // if (parts[0].startsWith("v")) {
      //   parts.shift();
      // }
      // this.storageService.cacheBust(parts[0]);
      return next.handle(req);
    }

    if (req.method === 'OPTIONS' || !cacheOptions) {
      return next.handle(req);
    }

    const cachedResponse = this.storageService.get<HttpResponse<any>>(req.urlWithParams);
    if (cachedResponse) {
      if (environment.debug) {
        console.debug('%c Cache hit: ' + req.urlWithParams, CommonValues.LoggingMessage_ColorPurple);
      }
      if (typeof cachedResponse.clone === 'function')
      {
        return of(cachedResponse.clone({ body: cachedResponse.body }));
      }
      return of(new HttpResponse<any>({
        body: cachedResponse.body,
        headers: cachedResponse.headers,
        status: cachedResponse.status,
        statusText: cachedResponse.statusText,
        url: cachedResponse.url ?? undefined
      }));
    }

    return next.handle(req).pipe(tap((event) => {
      if (event instanceof HttpResponse && event.url) {
        this.storageService.setHttpResponse(req.urlWithParams, event, cacheOptions.cacheType, cacheOptions.ttl);
      }
    }));
  }
}

